import { render, staticRenderFns } from "./DoneEditing.vue?vue&type=template&id=5933d275"
import script from "./DoneEditing.vue?vue&type=script&lang=js"
export * from "./DoneEditing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports